// Registro de errores en la RTDB primaria (autenticada).
//
// A diferencia de la version anterior —un fetch anonimo (PUT) a una RTDB
// externa hardcodeada (duoc-logistica), que recibia datos de TODOS los
// proyectos— esto:
//   1. Escribe via SDK de Firebase sobre la base PRIMARIA, que exige auth.
//   2. Guarda SOLO un mensaje de error generico: nunca perfiles de usuario,
//      configuracion del proyecto ni resultados.
//   3. Usa un path de destino configurable por entorno con
//      REACT_APP_ERROR_LOG_PATH (por defecto "ErrorLog").
import { ref, push, serverTimestamp } from 'firebase/database';
import { db } from 'auth/FirebaseAuth';
import { APP_VERSION_LABEL } from 'configs/VersionConfig';

const ERROR_LOG_PATH = (process.env.REACT_APP_ERROR_LOG_PATH || 'ErrorLog').trim();

// Normaliza cualquier entrada a un texto seguro, evitando volcar objetos
// completos (perfiles, configs, resultados) a la base.
const toSafeMessage = (input) => {
  if (input === null || input === undefined) return 'Error desconocido';
  if (typeof input === 'string') return input;
  if (input instanceof Error) return input.message || String(input);
  if (typeof input === 'object') {
    const code = input.code ? `[${input.code}] ` : '';
    const message = typeof input.message === 'string' ? input.message : '';
    return (code + message).trim() || 'Error (sin mensaje)';
  }
  return String(input);
};

const logError = (error) => {
  const message = toSafeMessage(error);
  try {
    push(ref(db, ERROR_LOG_PATH), {
      message,
      version: APP_VERSION_LABEL,
      timestamp: serverTimestamp(),
    }).catch((err) => console.error('Error al registrar log:', err));
  } catch (err) {
    console.error('Error al registrar log:', err);
  }
};

export default logError;
